import stringsBR from './strings/strings-br'
import stringsEN from './strings/strings-en'

import projectsBR from './projects/projects-br'
import projectsEN from './projects/projects-en'

const CODES = {
	BR: 'br',
	EN: 'en'
}

export default class Res {

	static strings = stringsEN;
	static projects = projectsBR;

	static locale(code) {
		switch(code) {
			case CODES.BR:
				Res.strings = stringsBR
				Res.projects = projectsBR
				break
			case CODES.EN:
				Res.strings = stringsEN
				Res.projects = projectsEN
				break
		}
	}
}


// WEBPACK FOOTER //
// ./src/values/Resources.js